/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  OrderRef,
  OrderRefOptional,
  OrderRefMetaI,
  OrderRefTrackedI,
} from "./order-ref";
import { OrderRefTracked, OrderRefMeta } from "./order-ref";

/**
 *
 * @export
 * @interface OrderPaymentWithOrderRef
 */
export interface OrderPaymentWithOrderRefOptional {
  /**
   *
   * @type {OrderRef}
   * @memberof OrderPaymentWithOrderRef
   */
  orderId?: OrderRefOptional;
}

export interface OrderPaymentWithOrderRef extends OrderPaymentWithOrderRefOptional {
  /**
   *
   * @type {OrderRef}
   * @memberof OrderPaymentWithOrderRef
   */
  orderId: OrderRef;
}

export interface OrderPaymentWithOrderRefTrackedI {
  /**
   *
   * @type {OrderRef}
   * @memberof OrderPaymentWithOrderRef
   */
  orderId?: OrderRefTrackedI;
  orderIdIsSet: boolean;
}

transformDatesMap.set(
  "OrderPaymentWithOrderRef",
  function (model: OrderPaymentWithOrderRef) {
    const transformDatesorderId = transformDatesMap.get("OrderRef");
    if (transformDatesorderId && model.orderId) {
      transformDatesorderId(model.orderId);
    }
  },
);

export type OrderPaymentWithOrderRefMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  orderId: PropertyMeta<OrderRefMetaI>;
}>;

export var OrderPaymentWithOrderRefMeta: OrderPaymentWithOrderRefMetaI =
  {} as OrderPaymentWithOrderRefMetaI;
OrderPaymentWithOrderRefMeta = typeMeta("OrderPaymentWithOrderRef", {
  orderId: propertyMeta("orderId", false, true, false, OrderRefMeta),
});

const metaI = OrderPaymentWithOrderRefMeta;

registerMeta(() => {});

export class OrderPaymentWithOrderRefTracked implements OrderPaymentWithOrderRefTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  orderId__I?: OrderRefTracked = undefined;
  orderIdIsSet: boolean = false;
  set orderId(v: undefined | OrderRefTracked) {
    if (v !== undefined) {
      this.orderId__I = v;
      this.orderIdIsSet = true;
    } else {
      this.orderId__I = v || undefined;
      this.orderIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get orderId() {
    return this.orderId__I;
  }
  constructor(
    config?: OrderPaymentWithOrderRefOptional,
    options?: AssignOptions,
  ) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {
    this.orderId?.setIds();
  }
  assignFrom(
    config: OrderPaymentWithOrderRefOptional,
    options?: AssignOptions,
  ): OrderPaymentWithOrderRefTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.orderId && this.orderIdApplyFilter(optionsRequired.filter)) {
      this.orderId = new OrderRefTracked(config.orderId, options);
      if (optionsRequired.unassign) this.orderIdIsSet = false;
      else this.orderIdIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): OrderPaymentWithOrderRefTrackedI {
    const cloned = {} as OrderPaymentWithOrderRefTrackedI;
    if (
      this.orderIdIsSetDeep() &&
      this.orderIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.orderIdIsSet = true;
      cloned.orderId = this.orderId?.removeUnset(filter);
    } else {
      //cloned.orderIdIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): OrderPaymentWithOrderRefTrackedI {
    if (!this.orderIdApplyFilter(filter)) this.orderIdIsSet = false;
    this.orderId?.unassignAll(filter);

    return this;
  }
  orderIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OrderPaymentWithOrderRefMeta.orderId,
      OrderPaymentWithOrderRefMeta,
      this.orderId,
      this,
    );
  }
  orderIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.orderIdIsSet && this.orderIdApplyFilter(filter)) return true;
    return this.orderId?.anySet(filter) == true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.orderIdIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
